import { Box, Dialog } from '@mui/material';
import { ColorChangeBtn } from '../../icons/ColorChange';
import { useState } from 'react';
import { SketchPicker } from 'react-color';
import { t } from 'i18next';
import {
  ColorBox, Container, Content, DialogWrapper, Header, Item, Label, PickerWrapper,
  StyledList,
} from './styles';

export type ChangeColorProps = {
  data: {color:string, description: string, index: number}[];
  setColor?: any;
  blueVersion?: boolean;
}

export type ButtonChangeColorProps = {
  onClick?: any;
  blueVersion?: boolean;
}

export type ChangeColorDialogProps = {
  onClose?:any;
  open: boolean;
  data: {color:string, description: string, index: number}[];
  setColor: any;
}

export function ChangeColor({ data, setColor, blueVersion }: ChangeColorProps): JSX.Element {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <ButtonChangeColor blueVersion={blueVersion} onClick={() => setShowDialog(!showDialog)} />
      <ChangeColorDialog
        onClose={() => setShowDialog(false)}
        open={showDialog}
        data={data}
        setColor={setColor}
      />
    </>
  );
}

export function ButtonChangeColor({ onClick, blueVersion }: ButtonChangeColorProps): JSX.Element {
  return (
    <Container>
      <ColorChangeBtn blueVersion />
      <div
        style={{
          paddingLeft: '8px', lineHeight: '150%', fontSize: '11px', fontWeight: blueVersion ? 'bold' : '',
        }}
        onClick={onClick}
      >
        {t('alterarCores')}
      </div>
    </Container>
  );
}

export function ChangeColorDialog({
  onClose, open, data, setColor,
}: ChangeColorDialogProps): JSX.Element {
  const [selected, setSelected] = useState({ color: '', description: '', index: 0 });
  const [showPickerColor, setShowPickerColor] = useState(false);

  return (
    <Dialog onClose={onClose} open={open} maxWidth="lg">
      <DialogWrapper expanded={showPickerColor}>
        <Header>
          <h3 style={{ fontWeight: 700 }}>{t('alterarCores')}</h3>
        </Header>
        <Content>
          <StyledList expanded={showPickerColor}>
            {data.map((itemData) => (
              <Item key={itemData.index}>
                <ColorBox
                  onClick={() => { setSelected(itemData); setShowPickerColor(true); }}
                  style={{ background: itemData.color }}
                />
                <Label>{itemData.description}</Label>
              </Item>
            ))}
          </StyledList>
          <PickerWrapper visible={showPickerColor}>
            {showPickerColor && (
              <SketchPicker
                color={selected.color}
                onChangeComplete={(color) => {
                  setColor(color, selected.index);
                  setSelected((prev) => ({
                    ...prev,
                    color: color.hex,
                  }));
                }}
                size="small"
              />
            )}
          </PickerWrapper>
        </Content>
      </DialogWrapper>
    </Dialog>
  );
}

export const ChangeColorSample = (option, setColor, color) => {
  const [showPickerColor, setShowPickerColor] = useState(false);
  return (
    <>
      <div style={{ backgroundColor: color, width: 18, height: 18 }} onClick={() => setShowPickerColor(!showPickerColor)} />
      <Box width={showPickerColor ? '100%' : '0%'} marginLeft="2%" zIndex={100}>
        {showPickerColor && (
          <SketchPicker
            color={color}
            onChangeComplete={(color) => setColor(color, option.index)}
          />
        )}
      </Box>
    </>
  );
};
